import { generateURL } from '../../../utils/api'

export function generateSearchURL (state, url, extraParams = {}) {
  return generateURL(
    url,
    {
      '?': {
        event: state.eventUUID,
        order: state.order,
        ...state.filters,
        ...extraParams,
      },
    }
  )
}



// WEBPACK FOOTER //
// ./src/redux/modules/search/selectors.js